import { render } from "./MyDevelopment.vue?vue&type=template&id=84ce97fe&scoped=true"
import script from "./MyDevelopment.vue?vue&type=script&lang=js"
export * from "./MyDevelopment.vue?vue&type=script&lang=js"

import "./MyDevelopment.vue?vue&type=style&index=0&id=84ce97fe&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84ce97fe"]])

export default __exports__